export default class StringUtil {
    public static smartLowerCase(s: string): string {
        const nonUpper = Array.from(s).filter((c) => c !== c.toUpperCase());
        if (nonUpper.length > 0) {
            return s.toLowerCase();
        } else {
            return s;
        }
    }

    public static wordList(words: string[]) {
        length = words.length;
        if (length === 0) {
            return '';
        } else if (length === 1) {
            return words[0];
        } else if (length === 2) {
            return `${words[0]} and ${words[1]}`;
        } else {
            let result = words[0];
            for (let i = 1; i < length; i++) {
                if (i < length - 1) {
                    result += `, ${words[i]}`;
                } else {
                    result += `, and ${words[i]}`;
                }
            }

            return result;
        }
    }

    public static toEnum(enumType: any, value: string): any {
        let k: keyof typeof enumType
        for (k in enumType){
            if (enumType[k] == value) {
                return enumType[k]
            }
        }
    }
}


